<div class="errorpage-content col-lg-6 offset-lg-3">
  <h1>{{ 'servererror.page.title' | translate }}</h1>
  <div class="error-text">
    <div [ishServerHtml]="'servererror.page.text' | translate"></div>
    <p class="text-muted" (click)="expand()" (keydown.enter)="expand()" tabindex="0">
      <ng-container [ngSwitch]="httpError?.status">
        <ng-container *ngSwitchCase="undefined"> {{ stringError | translate }} </ng-container>
        <ng-container *ngSwitchCase="0"> Server timeout </ng-container>
        <ng-container *ngSwitchDefault>
          Error code {{ httpError.status }}<br />
          {{ type }}
        </ng-container>
      </ng-container>
    </p>
    <pre *ngIf="expanded">{{ error | json }}</pre>
  </div>
</div>
